<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12" md="6">
                    <ValidationProvider name="car_model_id" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('car_model')">
                            <car-model-selectbox v-model="form.car_model_id" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="gear" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('gear')">
                            <parameter-selectbox :validate-error="errors[0]" v-model="form.gear"
                                                 code="car_gear_types"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="responsible_id" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('responsible')">
                            <staff-auto-complete v-model="form.responsible_id"
                                                 :validate-error="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="plate" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('plate')">
                            <b-form-input :validate-error="errors[0]" v-model="form.plate"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="kilometer" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('kilometer')">
                            <b-form-input :validate-error="errors[0]" v-model="form.kilometer"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="type" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('type')">
                            <parameter-selectbox :validate-error="errors[0]" v-model="form.type"
                                                 code="car_types"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="maintenance_date" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('maintenance_date')">
                            <select-date v-model="form.maintenance_date" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="status" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('status')">
                            <parameter-selectbox :validate-error="errors[0]" v-model="form.status"
                                                 code="car_statuses"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
        </ValidationObserver>

        <div class="col-6 mt-3 d-flex">
            <b-button
                @click="updateForm"
                type="button"
                :disabled="formLoading"
                variant="primary"
                class="btn-lg mr-2"
            >
                {{ $t("save") | toUpperCase }}
            </b-button>
        </div>
    </div>
</template>

<script>
    //Other
    import {ValidationProvider, ValidationObserver} from "vee-validate"
    //Service
    import CarService from "@/services/CarService";

    import CarModelSelectbox from "@/components/interactive-fields/CarModelSelectbox.vue";
    import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox.vue";
    import StaffAutoComplete from "@/components/interactive-fields/StaffAutoComplete.vue";

    export default {
        components: {
            ValidationProvider,
            ValidationObserver,

            CarModelSelectbox,
            ParameterSelectbox,
            StaffAutoComplete,

        },
        props: {
            formId: {
                type: Number,
            }
        },
        data() {
            return {
                formLoading: false,
                form: {
                    car_model_id: null,
                    gear: null,
                    responsible_id: null,
                    plate: null,
                    kilometer: null,
                    type: null,
                    maintenance_date: null,
                    status: null,
                }
            }
        },
        watch: {
            formId: function (val) {
                this.get(val)
            }
        },
        async created() {
            await this.get(this.formId)
        },
        methods: {
            get(id) {
                this.formLoading = true;
                CarService.get(id)
                               .then((response) => {
                                   this.form = response.data.data;
                                   this.formLoading = false;
                               })
                               .catch((error) => {
                                   if (error.data.message) {
                                       this.$toast.error(this.$t("api." + error.data.message));
                                   }
                               });
            },
            async updateForm() {
                const isValid = await this.$refs.formModalValidate.validate();
                if (isValid && this.formId) {
                    this.formLoading = true;

                    CarService.update(this.formId, this.form)
                                   .then((response) => {
                                       this.formLoading=false;
                                       this.$toast.success(this.$t("api." + response.data.message));
                                       this.$emit("updateFormSuccess")
                                   })
                                   .catch((error) => {
                                       this.showErrors(error, this.$refs.formModalValidate)
                                   })
                }
            }
        }
    }
</script>
